export class News
{
    id:string;
    title:string;
    brief:string;
    description:string;
    expirationDate:string;
    picture:string;
    url:string;
    modifiedDate: string;
}